import { convertArrToObj } from '@utils/odds.js';

export const getRound = (rounds, tableId) => {
  return rounds.find(element => element.table !== undefined && element.table.id.toString() === tableId);
}

// export const getRoundWithResult = (rounds, tableId) => {
//   return rounds.find(element => element.userBets.length > 0 && element.userBets[0].tableId !== undefined && element.userBets[0].tableId.toString() === tableId);
// }

export const getOdds = (rounds, tableId) => {
  const round = rounds.find(element => element.table.id === tableId);

  if(round === undefined || round.odds === undefined) return null;
  const odds = convertArrToObj(round.odds);

  return odds;
}

export const formatHistoryTitle = (round, createdDate) => {
  if(round !== undefined){
    return `Số rút ra ${round} ${createdDate}`;
  }
};
